import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, GetCompareMinMaxEqualDate, NonRequired } from 'src/lib/validation/ValidationTypes';
import { getLengthOfNumberBeforeAttributes, mapindexbyPath } from 'src/utils/formStruc';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const DurchfuehrungAntragStartupProjekte: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Durchführung' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default DurchfuehrungAntragStartupProjekte;

const formStrucPruefAssistenz = () => {
	const struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];

	return struc;
};
const formStruc = (): FormStrucItem[] => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Zeitplanung_Zeitplanung_Block_1,
					type: FORM_FIELDS_TYPES.editableTable,
					hideColumns: ['Zelle_2', 'Zelle_6', 'Group_id'],
					fieldProps: {
						Zelle_1: { width: '32rem' },
					},
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};
const customFormStrucZeitplanung = (startDatePath: string): FormStrucItem[] => {
	const hiddenColumns = ['Zelle_2', 'Zelle_6', 'Group_id'];

	let fields: any[] = [
		{
			key: 'Zelle_1',
			...P.Zeitplanung_Zeitplanung_Block_1.schema.attributes.Zelle_1,
		},
		{
			key: 'Zelle_2',
			...P.Zeitplanung_Zeitplanung_Block_1.schema.attributes.Zelle_2,
		},
		{
			key: 'Zelle_4',
			...P.Zeitplanung_Zeitplanung_Block_1.schema.attributes.Zelle_4,
			validation: [
				{ validateFunction: NonRequired },
				{
					validateFunction: GetCompareMinMaxEqualDate,
					onlyValidateOnNonEmptyValue: true,
					params: [
						P.Allgemein_Geplante_Projektlaufzeit_von.path,
						P.Allgemein_Geplante_Projektlaufzeit_bis.path,
					],
				},
			],
		},
		{
			key: 'Zelle_5',
			...P.Zeitplanung_Zeitplanung_Block_1.schema.attributes.Zelle_5,
			validation: [
				{ validateFunction: NonRequired },
				{
					validateFunction: GetCompareMinMaxEqualDate,
					onlyValidateOnNonEmptyValue: true,
					params: [
						startDatePath,
						P.Allgemein_Geplante_Projektlaufzeit_bis.path,
					],
				},
			],
		},
	];

	const visibleFields = fields.filter((field) => !hiddenColumns.includes(field.key));

	return [{ fields: visibleFields }];
};
function getZeitplanungStruc(application: any): FormStrucItem[] {
	// const result = getFormStrucComponentTable(application, formStruc);
	let result: any = [];
	const componentTableLength = get(application, P.Zeitplanung_Zeitplanung_Block_1.path, []).length;
	const startDate = P.Zeitplanung_Zeitplanung_Block_1.schema.attributes.Zelle_4.path;
	const parentObject = P.Zeitplanung_Zeitplanung_Block_1;
	const parentObjectPath = get(parentObject, 'path', '');
	let indexLength = getLengthOfNumberBeforeAttributes(parentObjectPath);

	for (let i = 0; i < componentTableLength; i++) {
		//create index for dynamic param
		const paramPath = parentObjectPath.slice(0, parentObject.path.length) + `.${i}` + startDate.slice(parentObject.path.length - indexLength);
		mapindexbyPath(customFormStrucZeitplanung(paramPath), i, parentObject).forEach((element: any) => {
			result.push(element);
		});
	}

	return result;
}
const formStrucFunktion = () => {
	return [
		{
			fields: [
				{
					...P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Projektbeschreibung_Star_0244823998_eguenstigten_Weiterzureichen,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};

export const getFormStrucDurchfuehrungAntragStartupProjekte = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Pruefstatus.path,
			P.Projektbeschreibung_Start_Up_Projekte.schema.attributes.Pruefung_Durchfuehrung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), getZeitplanungStruc(application), formStrucFunktion());
	return concat(getZeitplanungStruc(application), formStrucFunktion());
};
